export const DEFAULT_FILTER_SOAL = [
  "cerita",
  "pg",
  "polling",
  "essay",
  "true_false",
  "menjodohkan",
  "pernyataan",
];
